import Debug from 'debug';
import { customElement, property } from 'lit/decorators';
import { LitElement, nothing, PropertyValues } from 'lit';
import { dataBroker } from '../services/DataBroker';
import { PqdSqlClient } from './pdq-sqlite-client';
import { sqliteBroker } from '../services/SqliteBroker';

const log = Debug('pdq:sqlite:database');
@customElement('pdq-sqlite-local-database')
export class PdqSqliteLocalDatabase extends LitElement  {

  @property({type: String}) database: string | undefined

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.refresh().catch(e => log(`failed to refresh - ${e}`))
  }
  protected updated(_changedProperties: PropertyValues) {
    super.updated(_changedProperties);
    this.refresh().catch(e => log(`failed to refresh - ${e}`))
  }

  cacheKey = ''
  async refresh(){
    if (!this.database) {
      log(`refresh failed... no database path / name`)
      return
    }
    const ck = `${this.database}`
    if (this.cacheKey == ck)
      return
    this.cacheKey = ck
    log(`opening local sqlite instance[${this.database}]`)
    const client = await sqliteBroker.getDatabaseClient(this.database)
    await client.open(this.database)
    sqliteBroker.setDatabaseReady(this.database)
    log(`local sqlite instance[${this.database}] is open and ready`)
  }
}